import pluralize from 'pluralize';

import {
	EVINCED_SEVERITIES,
	EVINCED_SEVERITIES_IDS,
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition,
	OptionType
} from '@evinced-private/ui-common';

import {
	DEFAULT_MOBILE_PLATFORM,
	MOBILE_APP_ID_FILTER_ID,
	MOBILE_PLATFORM_FILTER_ID,
	MOBILE_PLATFORM_OPTIONS
} from 'src/apps/dashboard/constants/MobileDashboard.constants';
import { createSingleSelectFilter } from 'src/apps/dashboard/helpers/FilterCreationHelpers';
import {
	DEFAULT_UNIT_ID_DISPLAY_NAME,
	UNIT_ID_LABEL_KEY
} from 'src/common/consts/platformConfigConsts';

import { DASHBOARD_DATE_RANGE_OPTIONS } from './DashboardFiltersDefinitions';

const MOBILE_DATE_RANGE_FILTER: ISelectFilterDefinition = {
	id: 'dateRange',
	label: 'Date range',
	filterType: 'select',
	defaultValue: [DASHBOARD_DATE_RANGE_OPTIONS[0]],
	componentProps: {
		placeholder: 'Last 7 days',
		isMultiple: false,
		id: 'dateRange',
		label: 'Date range',
		listboxWidth: '180px'
	}
};

const MOBILE_PLATFORM_FILTER: ISelectFilterDefinition = {
	id: MOBILE_PLATFORM_FILTER_ID,
	label: 'Platform',
	filterType: 'select',
	defaultValue: [{ value: DEFAULT_MOBILE_PLATFORM, label: 'All platforms' }],
	componentProps: {
		placeholder: 'All platforms',
		isMultiple: false,
		id: MOBILE_PLATFORM_FILTER_ID,
		label: 'Platform',
		listboxWidth: '180px'
	}
};

const MOBILE_ISSUES_SEARCH_FILTER: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

const MOBILE_APP_ID_FILTER: ISelectFilterDefinition = {
	id: MOBILE_APP_ID_FILTER_ID,
	label: 'App ID',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'All App IDs',
		allSelectedPlaceholder: 'All App IDs',
		someItemsSelectedText: (n: number) => `App IDs (${n})`,
		isMultiple: true,
		id: MOBILE_APP_ID_FILTER_ID,
		label: 'App ID'
	}
};

const MOBILE_SEVERITY_FILTER: ISelectFilterDefinition = {
	id: 'severities',
	label: 'Severity',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select',
		allSelectedPlaceholder: 'All Severities',
		someItemsSelectedText: (n: number) => `Severities (${n})`,
		isMultiple: true,
		id: 'severities',
		label: 'Severity',
		listboxWidth: '150px'
	}
};

export const MOBILE_SEVERITY_OPTIONS: OptionType[] = [
	{ value: EVINCED_SEVERITIES_IDS.CRITICAL, label: EVINCED_SEVERITIES.CRITICAL },
	{ value: EVINCED_SEVERITIES_IDS.SERIOUS, label: EVINCED_SEVERITIES.SERIOUS },
	{ value: EVINCED_SEVERITIES_IDS.MODERATE, label: EVINCED_SEVERITIES.MODERATE },
	{ value: EVINCED_SEVERITIES_IDS.MINOR, label: EVINCED_SEVERITIES.MINOR },
	{ value: EVINCED_SEVERITIES_IDS.BEST_PRACTICE, label: EVINCED_SEVERITIES.BEST_PRACTICE },
	{ value: EVINCED_SEVERITIES_IDS.NEEDS_REVIEW, label: EVINCED_SEVERITIES.NEEDS_REVIEW }
];

export const MOBILE_FILTER_DEFINITIONS: IFilterDefinition[] = [
	MOBILE_PLATFORM_FILTER,
	MOBILE_APP_ID_FILTER,
	MOBILE_DATE_RANGE_FILTER
];

export const getMobileIssuesFilterDefinitions = (
	unitIdDisplayName: string = DEFAULT_UNIT_ID_DISPLAY_NAME
): IFilterDefinition[] => {
	const unitIdFilter = createSingleSelectFilter(UNIT_ID_LABEL_KEY, unitIdDisplayName, {
		allSelectedPlaceholder: `All ${pluralize(unitIdDisplayName)}`
	});

	return [
		MOBILE_ISSUES_SEARCH_FILTER,
		MOBILE_PLATFORM_FILTER,
		MOBILE_APP_ID_FILTER,
		unitIdFilter,
		MOBILE_SEVERITY_FILTER,
		MOBILE_DATE_RANGE_FILTER
	];
};

export const MOBILE_FILTER_OPTIONS: Record<string, OptionType[]> = {
	dateRange: DASHBOARD_DATE_RANGE_OPTIONS,
	[MOBILE_PLATFORM_FILTER_ID]: MOBILE_PLATFORM_OPTIONS,
	severities: MOBILE_SEVERITY_OPTIONS
};
